import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthAPI } from '@/api/modules/auth';
import { useAuthBridge } from '@/hooks/useAuth';

export default function Login(){
  const auth = useAuthBridge();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(() => localStorage.getItem('rememberCreds') === '1');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  useEffect(() => { const saved = localStorage.getItem('savedCreds'); if (remember && saved) { try { const { username: u, password: p } = JSON.parse(saved); setUsername(u||''); setPassword(p||''); } catch {} } }, []);
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault(); setError(null); setLoading(true);
    try {
      const { data } = await AuthAPI.login(username, password);
      if (!data.success || !data.token) throw new Error(data.message || 'Credenziali non valide');
      auth?.setToken(data.token); auth?.setUser(data.user || null);
      if (remember) { localStorage.setItem('savedCreds', JSON.stringify({ username, password })); localStorage.setItem('rememberCreds','1'); } else { localStorage.removeItem('savedCreds'); localStorage.setItem('rememberCreds','0'); }
      navigate('/dashboard/home', { replace: true });
    } catch (err:any) { setError(err?.message || 'Errore di rete'); } finally { setLoading(false); }
  };
  return (
    <form onSubmit={handleLogin} style={{ display:'grid', gap:8, maxWidth:320, margin:'40px auto' }}>
      <h1>MontanstahlPeople</h1>
      <label>Username<input aria-label="Username" required value={username} onChange={(e)=>setUsername(e.target.value)} /></label>
      <label>Password<input aria-label="Password" required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} /></label>
      <label style={{ display:'flex', alignItems:'center', gap:6 }}><input type="checkbox" checked={remember} onChange={(e)=>setRemember(e.target.checked)} />Resta collegato</label>
      {error && <div style={{ color:'red' }}>{error}</div>}
      <button disabled={loading}>{loading? 'Accesso…' : 'Login'}</button>
    </form>
  );
}
